var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentWithHeader", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [_c("div", { staticClass: "col" })]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "div",
              {
                staticClass: "wrapper-content",
                style: [{ height: _vm.wrapperContentHeight + "px" }]
              },
              [
                _c("section", { staticClass: "section-info" }, [
                  _c("div", { staticClass: "wrapper-change row no-margin" }, [
                    _c("div", { staticClass: "icon col-12 text-center" }, [
                      _c("i", { staticClass: "fas fa-clipboard-check" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "change col-12 text-center text-success" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("apps.pos.message.insertposbillsuccess")
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.receiptInfo.paymentMethod ===
                    _vm.POS_PAYMENT_METHOD.CASH
                      ? _c("div", { staticClass: "paid col-12 text-center" }, [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("apps.pos.message.changecash", {
                                  number1: _vm.getNumber(
                                    _vm.receiptInfo.change
                                  ),
                                  number2: _vm.getNumber(_vm.receiptInfo.paid)
                                })
                              )
                            }
                          })
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.showQrCodeReceipt
                    ? _c("div", { staticClass: "wrapper-scan-qrcode" }, [
                        _c("div", { staticClass: "inner" }, [
                          _c("img", {
                            attrs: { src: _vm.qrcodeReceiptDataUrl }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "message" }, [
                            _c("i", { staticClass: "fas fa-level-down-alt" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("message.scandownloadreceipt")
                                  ) +
                                  "\n              "
                              )
                            ])
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "wrapper-action row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "text-header col-12 text-center",
                        staticStyle: { "margin-top": "15px" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("apps.pos.message.howdoyouwantreceipts")
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "outer-input row col-12" }, [
                      _c(
                        "div",
                        { staticClass: "inner-input col-12 row text-center" },
                        [
                          _c("div", { staticClass: "input-group mb-3" }, [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "input-group-text",
                                  attrs: { id: "basic-addon1" }
                                },
                                [_c("i", { staticClass: "fas fa-envelope" })]
                              )
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.email,
                                  expression: "email"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                placeholder: _vm.$t("placeholder.email"),
                                type: "text",
                                "aria-describedby": "basic-addon1"
                              },
                              domProps: { value: _vm.email },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.email = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          [
                            _vm.isSendingEmail
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-sendmail",
                                    attrs: { disabled: true }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-spinner spin"
                                    })
                                  ]
                                )
                              : _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-sendmail",
                                    attrs: {
                                      disabled: _vm.email.trim().length === 0
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onclickSentEmail()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("button.send")) +
                                        "\n                "
                                    )
                                  ]
                                )
                          ]
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _vm.posSettings.qrcode_receipt.auto === false
                      ? _c("div", { staticClass: "outer-input row col-12" }, [
                          _c(
                            "div",
                            {
                              staticClass: "inner-input col-12 row text-center",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  return _vm.setQRCodeDataUrl()
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "input-group mb-3" }, [
                                _c(
                                  "div",
                                  { staticClass: "input-group-prepend" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "input-group-text" },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-qrcode",
                                          staticStyle: {
                                            position: "relative",
                                            left: "2px"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "message" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.showqrcodebutton"))
                                  )
                                ])
                              ])
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "outer-input row col-12" }, [
                      _c(
                        "div",
                        {
                          staticClass: "inner-input col-12 row text-center",
                          staticStyle: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.onclickPrint()
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "input-group mb-3" }, [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c("span", { staticClass: "input-group-text" }, [
                                _c("i", { staticClass: "fas fa-print" })
                              ])
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "message" }, [
                              _vm._v(_vm._s(_vm.$t("message.printreceipt")))
                            ])
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "outer-input row col-12" }, [
                      _c(
                        "div",
                        {
                          staticClass: "inner-input col-12 row text-center",
                          staticStyle: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.onClickDone()
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "input-group mb-3" }, [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c("span", { staticClass: "input-group-text" }, [
                                _c("i", { staticClass: "fas fa-ban" })
                              ])
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "message" }, [
                              _vm._v(_vm._s(_vm.$t("message.nothanks")))
                            ])
                          ])
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "section-newsale" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-newsale btn-block",
                      on: {
                        click: function($event) {
                          return _vm.onClickDone()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("message.newsale")) +
                          "\n        "
                      )
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("receipt-view", {
              staticClass: "receipt-template",
              staticStyle: {
                position: "fixed",
                "z-index": "-1",
                top: "1mm",
                left: "1mm",
                "font-family": "tahoma",
                color: "black",
                width: "100%"
              },
              attrs: {
                shop_logo: _vm.receiptInfoProps.shopLogo,
                shop_name: _vm.receiptInfoProps.shopName,
                shop_address: _vm.receiptInfoProps.shopAddress,
                shop_tax_id: _vm.receiptInfoProps.shopTaxId,
                shop_tax_title: _vm.receiptInfoProps.shopTaxTitle,
                shop_tel: _vm.receiptInfoProps.shopTel,
                orders: _vm.receiptInfoProps.orders,
                total_price: _vm.receiptInfoProps.totalPrice,
                receipt_info: _vm.receiptInfoProps.receiptInfo,
                date_time: _vm.receiptInfoProps.dateTime,
                text_footer: _vm.receiptInfoProps.textFooter,
                font_size: _vm.receiptInfoProps.fontSize
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-455dda32", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-455dda32","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/mobile/include/PaymentComplate.vue
// module id = null
// module chunks = 